import { render, staticRenderFns } from "./distributorCooperation.vue?vue&type=template&id=a7443604&scoped=true"
import script from "./distributorCooperation.vue?vue&type=script&lang=js"
export * from "./distributorCooperation.vue?vue&type=script&lang=js"
import style0 from "./distributorCooperation.vue?vue&type=style&index=0&id=a7443604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7443604",
  null
  
)

export default component.exports